<template>
    <div class="border-gray-400 boder">
        <div class="p-3 bg-cta rounded-tl-md rounded-tr-md">
            <h2 class="text-black font-bold text-lg">Inscrição Gratuita</h2>
        </div>
        <div class="p-4 text-center bg-white flex">
            <div class="text-right w-7/12 pr-2">
                <p class="text-base leading-5">Com essa bolsa, você <br />terá desconto de:</p>
            </div>
            <div class="w-5/12 pl-2 text-left -mt-2">
                <h1 class="text-primary text-5xl font-extrabold">{{ product?.discount }}%</h1>
                <p class="font-bold text-xs text-black">em todas as mensalidades</p>
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
	import { storeToRefs } from "pinia";
	import { useCheckoutStore } from "~~/store/checkout";

	const checkout = useCheckoutStore();
	const { product } = storeToRefs(checkout);
    
</script>